import YFormPhoneLabel from './PhoneLabel';

export { YFormPhoneLabel };
export default YFormPhoneLabel;
